import React from "react";
import { Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Button } from "../../ui";
import "./SelectModal.css";

const SelectModal = ({
  show,
  onHide,
  title,
  loading = false,
  options = [],
  value = "",
  onChange,
  onSelect,
  optionLabel = (opt) => opt.name,
  optionValue = (opt) => opt.id,
  confirmButtonText,
  cancelButtonText,
  emptyMessage,
  loadingMessage,
  placeholderOption,
  topContent = null,
}) => {
  const { t } = useTranslation("layout");
  const resolvedTitle = title ?? t("selectModal.title");
  const resolvedConfirm = confirmButtonText ?? t("selectModal.confirm");
  const resolvedCancel = cancelButtonText ?? t("selectModal.cancel");
  const resolvedEmpty = emptyMessage ?? t("selectModal.empty");
  const resolvedLoading = loadingMessage ?? t("selectModal.loading");
  // Пункт-заглушка в списке. Заголовок попапа уже показан в шапке,
  // поэтому второй раз его внутри селекта не повторяем.
  const resolvedPlaceholder =
    placeholderOption ?? t("selectModal.placeholderOption");

  const handleConfirm = () => {
    if (value) {
      const selectedOption = options.find((opt) => optionValue(opt) === value);
      onSelect(selectedOption);
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered className="select-modal">
      <Modal.Header closeButton>
        <Modal.Title>{resolvedTitle}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {topContent}
        {loading ? (
          <div className="pick-modal__note">{resolvedLoading}</div>
        ) : options.length > 0 ? (
          <select
            aria-label={resolvedTitle}
            className={`form-select select-modal__select${
              value ? "" : " is-placeholder"
            }`}
            value={value}
            onChange={(e) => onChange(e.target.value)}>
            <option value="">{resolvedPlaceholder}</option>
            {options.map((option) => (
              <option key={optionValue(option)} value={optionValue(option)}>
                {optionLabel(option)}
              </option>
            ))}
          </select>
        ) : (
          <div className="pick-modal__note">{resolvedEmpty}</div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          {resolvedCancel}
        </Button>
        <Button
          variant="primary"
          disabled={!value || loading}
          onClick={handleConfirm}>
          {resolvedConfirm}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default SelectModal;
